import { Icon, type IconSize } from '../../icons';

type P = {
  size: IconSize;
  subtype: string;
};

// eslint-disable-next-line complexity -- We want this switch here
const ApplicationFileIcon = ({ size, subtype }: P) => {
  const [baseSubtype] = subtype.split(';');

  switch (baseSubtype) {
    case 'epub+zip':
    case 'pdf':
    case 'postscript':
    case 'vnd.ms-xpsdocument':
      return <Icon icon="pdf-file" size={size} />;
    case 'gzip':
    case 'vnd.rar':
    case 'x-7z-compressed':
    case 'x-rar-compressed':
    case 'x-tar':
    case 'zip':
      return <Icon icon="zip-file" size={size} />;
    case 'javascript':
      return <Icon icon="code-file" size={size} />;
    case 'msword':
    case 'rtf':
    case 'vnd.ms-works':
    case 'vnd.oasis.opendocument.text':
    case 'vnd.openxmlformats-officedocument.wordprocessingml.document':
      return <Icon icon="document-file" size={size} />;
    case undefined:
      return <Icon icon="default-file" size={size} />;
    case 'vnd.apple.keynote':
    case 'vnd.ms-powerpoint':
    case 'vnd.oasis.opendocument.presentation':
    case 'vnd.openxmlformats-officedocument.presentationml.presentation':
      return <Icon icon="ppt-file" size={size} />;
    case 'vnd.ms-excel':
    case 'vnd.oasis.opendocument.spreadsheet':
    case 'vnd.openxmlformats-officedocument.spreadsheetml.sheet':
      return <Icon icon="sheet-file" size={size} />;
    case 'x-virtualbox-vbox':
    case 'x-vmware-vmx':
      return <Icon icon="video-file" size={size} />;
    default:
      return <Icon icon="default-file" size={size} />;
  }
};

export default ApplicationFileIcon;
